<dx-drop-down-button
  [useSelectMode]="false"
  [items]="menu"
  displayExpr="name"
  keyExpr="id"
  [text]="text"
  [icon]="icon"
  [selectedItemKey]="current.id"
  stylingMode="outlined"
  width="180"
  (onItemClick)="onItemClick($event)"
  (onSelectionChanged)="onSelectionChanged($event)"
></dx-drop-down-button>
